module.exports = __webpack_public_path__ + "img/nav_icon_setup_normal.4de3283b.png";